<template>
    <div>
        <NavBarLight></NavBarLight>
        <div class="content-start">
            <div class="container-fluid" id="main-container">
                <div class="row" id="challenge-content">
                    <div class="col-lg-8 col-md-12 text-left" id="challenge-content-text">
                        <div class="title">
                            <h4><span><img v-if="challengeObj.Apply_icon !== 'no'" alt="challenge icon" class="challenge-icon" :src="challengeObj.Apply_icon"/>{{challengeObj['.key']}}</span></h4>
                        </div><br>

                        <div v-if="!isMobile()" class="problem-text embed-responsive embed-responsive-1by1">
                            
                            <embed class="embed-responsive-item" :src="challengeObj.Problem_pdf + '#toolbar=0&navpanes=0&scrollbar=1&zoom=80'">
                            
                        </div>

                        <div v-else>
                            <a :href="challengeObj.Problem_pdf" download>Download Challenge</a>
                        </div>

                        <br><br>

                        <div class="instruction-text">
                            <div class="instruction-title">
                                <h5 >Instructions</h5>
                            </div>
                            <div class="every-instruction" v-for="(instruction, index) of challengeObj.Instructions" :key="index">
        
                                <span><font-awesome-icon class="fa" icon="check-circle" />
                                    {{instruction}}</span>
                            </div>
                        </div><br><br>
                        
                        
                    </div>

                    <div class="col-lg-4 col-md-4">
                        <RegisterCard 
                            v-bind:title="challengeObj['.key']"
                            v-bind:rewardText="challengeObj.Reward"
                            v-bind:slug = "challengeObj.Slug"
                            v-bind:clickCard="clickCard"
                            v-bind:apply="challengeObj.Apply"
                            v-bind:deadline="challengeTS"
                            calledFrom="ApplyChallenge"
                            ctaText="SUBMIT WORK"
                            ctaUrl="/submit-work">
                        </RegisterCard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import NavBarLight from '@/components/NavBarLight.vue'
import RegisterCard from '@/components/RegisterCard.vue'
import firebase from '../services/firebase'


export default {
    name: 'ApplyChallenge',
    components: {
        NavBarLight,
        RegisterCard
    },
    data: function() {
        return {
            challenges: [],
            deadlineSubmission: null,
            deadlineVoting: null,
            registeredUsers: [],
            challengeKey: '',
            challengeTS: null,
            fbLoaded: false
        }
    },
    firebase: {
         challenges: firebase.database().ref('challenges/UX').orderByChild('Enabled').equalTo(true)
    },
    computed: {
        challengeObj: function() {
            for (var key in this.challenges) {
                console.log("slug is " + this.challenges[key].Slug);
                if (this.challenges[key].Slug == this.$route.params.slug) {
                    console.log("slug is matched for " + this.challenges[key].Slug);
                    this.challengeKey = this.challenges[key]['.key'];
                    this.deadlineSubmission = this.challenges[key].Deadline;
                    this.deadlineVoting = this.challenges[key].Voting;
                    this.registeredUsers = this.challenges[key].Registered_users;
                    return this.challenges[key];
                }
            }
        }
        
    },
    created: function() {
        mixpanel.track("approved entered challenge", 
        {
            "challenge_name": this.$route.params.slug,
            "user_id": firebase.auth().currentUser.uid,
            "email": firebase.auth().currentUser.email
        });
        firebase.database().ref('user_submissions/' + firebase.auth().currentUser.uid + '/' + this.$route.params.slug).on('value', (submission) => {
            this.challengeTS = submission.val().timestamp;
            this.fbLoaded = true;
        });
    },
    methods: {
        clickCard: function(slug_sent) {
           // alert("register clicked, in challenge vue, slug sent is " + slug_sent);
            mixpanel.track("approved candidate taking challenge", 
            {
                "company_challenge": this.$route.params.slug,
                "user_id": firebase.auth().currentUser.uid,
                "email": firebase.auth().currentUser.email
            });
            
            this.$router.push(this.$route.path + '/submit-work');
            
        },
        getDate: function(ts) {
            return new Date(ts*1000);
        },
        isMobile: function() {
            if (navigator.userAgent.match(/Android/i)) {
                return true;
            } else if (navigator.userAgent.match(/iPhone/i)) {
                return true;
            } else if (navigator.userAgent.match(/iPad/i)) {
                return true;
            } else {
                return false;
            }
        }
    }
}
</script>


<style scoped>

    .content-start {
        margin-top:50px;
    }

    .title {
        margin-top:20px;
        margin-left:10px;
    }

    #main-container {
        color:#222;
        background-color:#f8faff !important;
    }

    #challenge-content {
        margin-left:3.5%;
        margin-right:4%;
        padding-right:0%;
    }

    @media(min-width:600px) {
        .card {
            margin-left:0;
        }
    }

    #challenge-content-text {
        padding-right:7%;
    }

    .challenge-icon {
        margin-left:-10px;
        margin-right:20px; 
        width:50px;
        height:50px;
    }

    .problem-title {
        font-weight: 500;
        margin-bottom:10px;
    }

    .instruction-title {
        font-weight: 500;
        margin-bottom:10px;
    }

    .submission-title {
        font-weight: 500;
        margin-bottom:10px;
    }

    .every-instruction {
        margin-bottom:3px;
    }

    .problem-text {
        font-size: 0.9rem;
    }

    .instruction-text {
        font-size: 0.9rem;
    }

    .submission-text {
        font-size: 0.9rem;
    }

    .fa {
        margin-right:10px; 
        color:green
    }

</style>
